<template>
<div>
	<!-- <TopAppBarDrawer></TopAppBarDrawer> -->
	<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
								aria-label="Open navigation menu">menu</button>-->
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click="login" @keypress="login" tabindex="0">{{$t('3323')}}</div>
			</section>
		</div>
    </header>
<main class="main-wrapper full flex-grow-1">
	<div class="container container--small pdt-30 ">
			<form @submit.prevent="changePassword()" novalidate>
			<div class="pdl-24 pdr-24">
				<div class="t-headline11 font-m mgt-20 mgb-8">{{$t('329')}}</div>
				<div class="body1 font-r t-color-bodyGrayA">{{$t('330')}}</div>
				<div class="mgt-40 mgb-8">
					<label
						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
						data-mdc-auto-init="MDCTextField"
						:class="submitState && currentPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
							id="currentPasswordEl">
						<span class="mdc-notched-outline">
										<span class="mdc-notched-outline__leading"></span>
										<span class="mdc-notched-outline__notch">
														<span class="mdc-floating-label" id="password-message">{{$t('331')}}</span>
										</span>
										<span class="mdc-notched-outline__trailing"></span>
						</span>
										<input class="mdc-text-field__input" type="password" aria-labelledby="password-message"
												v-model="currentPassword"
												v-validate="'required'"
												ref="currentPassword"
												id="currentPassword"
												name="currentPassword"
												maxlength="50" />
						<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
										role="button">report_problem</i>
		</label>
		<div class="mdc-text-field-helper-line">
			<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
							id="my-helper-id" aria-hidden="true"
							:class="submitState && currentPasswordInvalidCheck ? 't-color-mainBtn' : ''"> 	</div>
		</div>
	</div>

	<div class="divider"></div>
	<div class="mgt-16">
					<label
									class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
									data-mdc-auto-init="MDCTextField"
									:class="submitState && newPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
									id="newPasswordEl">
									<span class="mdc-notched-outline">
													<span class="mdc-notched-outline__leading"></span>
													<span class="mdc-notched-outline__notch">
																	<span class="mdc-floating-label" >{{$t('332')}}</span>
													</span>
													<span class="mdc-notched-outline__trailing"></span>
									</span>
									<input class="mdc-text-field__input" type="password"
											aria-labelledby="password-message"
											v-model="newPassword"
											v-validate="'required|min:8|verify_password'"
											ref="newPassword"
											id="newPassword"
											name="newPassword"
											maxlength="50"
											/>
									<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									:class="newPasswordConfirmValidIcon === 'check' ? 'check_show' : ''"
										role="button">{{newPasswordValidIcon}}</i>
					</label>
					<div class="mdc-text-field-helper-line d-block">
									<div
													class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
													:class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''" >
													{{$t('333')}}
									</div>
					</div>
	</div>
	<div class="mgt-16">
		<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
				data-mdc-auto-init="MDCTextField"
				:class="submitState && newPasswordConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
				id="newPasswordConfirmEl">
				<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
										<span class="mdc-floating-label" >{{$t('334')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
				</span>
					<input class="mdc-text-field__input" type="password" aria-labelledby="password-message"
							v-model="newPasswordConfirm"
							v-validate="'required|confirmed:newPassword'"
							ref="newPasswordConfirm"
							id="newPasswordConfirm"
							name="newPasswordConfirm"
							maxlength="50"
					/>
				<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
				:class="newPasswordConfirmValidIcon === 'check' ? 'check_show' : ''"
								role="button">{{newPasswordConfirmValidIcon}}</i>
			</label>
			<div class="mdc-text-field-helper-line d-block">
				<div
					class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
					:class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''" >
						{{submitState && newPasswordConfirmInvalidCheck ? $t('341') : $t('335')}}
				</div>
			</div>
	</div>
	<div class="mgt-30 mgb-50">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"
					type="submit">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('336')}}</span>
			</button>
			<button class="mdc-button bg-white t-color-secondaryBtnText  " @click.prevent="nextChangePassword()" @keypress.prevent="nextChangePassword()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('337')}}</span>
			</button>
	</div>
</div>
	</form>
		</div>
	</main>
</div>
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from '@/api/memberApi.js'
import loginApi from "@/api/loginApi.js"
import popupApi from "@/api/popupApi.js"
import { mapState, mapMutations } from "vuex";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import localStorageUtil from "@/utils/localStorageUtil";
import { userMixin } from "@/mixins/user"

export default {
	mixins: [userMixin],
	data() {
		return {
			currentPassword: '',
			newPassword: '',
			newPasswordConfirm: '',
			currentPasswordTextField: null,
			newPasswordTextField: null,
			newPasswordConfirmTextField: null,
			submitState: false,
			newPasswordValidIcon: 'report_problem',
			newPasswordConfirmValidIcon: 'report_problem',
			params : "",
			redirectPath: "",
			popupData: null,
			popupImage: null,
			socialFirstName: "",
			socialLastName: "",
			socialFullName: "",
			socialEmail: "",
			socialAuth: false,
			isDrawerOpen: false,
			staticMode:'',
			next:'',
			title: localStorage.getItem('brandName'),
      isIdpService: localStorageUtil.isIdpServiceValidate()
		}
	},
	components:{
		TopAppBarDrawer
	},
	computed : {
		currentPasswordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('currentPassword')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}
			this.currentPasswordTextField.valid === !returnValue ? '' : this.currentPasswordTextField.valid = !returnValue
			return returnValue
		},

		newPasswordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('newPassword')) {
					returnValue = true
					this.newPasswordValidIcon = 'report_problem'
				}else {
					returnValue = false
					this.newPasswordValidIcon = 'check'
				}
			}
			this.newPasswordTextField.valid === !returnValue ? '' : this.newPasswordTextField.valid = !returnValue
			return returnValue
		},

		newPasswordConfirmInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('newPasswordConfirm')) {
					returnValue = true
					this.newPasswordConfirmValidIcon = 'report_problem'
				}else {
					returnValue = false
					this.newPasswordConfirmValidIcon = 'check'
				}
			}
			this.newPasswordConfirmTextField.valid === !returnValue ? '' : this.newPasswordConfirmTextField.valid = !returnValue
			return returnValue
		},

	},

	mounted() {
		this.setMaterialUi()
		this.$refs.currentPassword.focus()
		this.paramsss =JSON.parse(localStorage.getItem("userParams"));
	},
	created(){
		localStorage.setItem('learn', 'setChangePassword')
	},
	methods: {
		setMaterialUi() {
			this.currentPasswordTextField = new MDCTextField(document.querySelector('#currentPasswordEl'))
			this.currentPasswordTextField.useNativeValidation = false
			this.newPasswordTextField = new MDCTextField(document.querySelector('#newPasswordEl'))
			this.newPasswordTextField.useNativeValidation = false
			this.newPasswordConfirmTextField = new MDCTextField(document.querySelector('#newPasswordConfirmEl'))
			this.newPasswordConfirmTextField.useNativeValidation = false
			window.mdc.autoInit();
			const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			if(document.querySelector('.mdc-text-field')){
				var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
			}
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		...mapMutations("join", [
			"SET_JOINSTART",
			"SET_SOCIAL_LINK",
			"SET_PUSH_NOTIFICATION",
			"SET_NAME_FIRST",
			"SET_NAME_LAST",
			"SET_NAME_FULL",
			"SET_LOGINID",
			"SET_SOCIAL_ID",
			"INIT_JOIN_STORE",
			]),

		login() {
      if (this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        this.$router.push("/login");
      }
		},

		changePassword() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
						let params = {
							password: this.currentPassword,
							newPassword: this.newPassword
						}
						let responseData = null
						let alertParams = null
						memberApi.changePassword(params).then((response) => {
							responseData = response.data.data

							if (responseData) {
								alertParams = {
									title: this.$t('325'),
									content: this.$t('326'),
									accept: this.$t('328'),
								}

								this.$alert(alertParams).then(() => {
									let paramss = {
										userId: this.paramsss.userId,
										password: this.newPassword,
										device: {
											type: this.paramsss.device.type,
										},
									};
								   this.checkSignInStatus(paramss);
								})
							} else {
								this.$snackOpen({contents:this.$t('957')}.then(() => {}))
							}

						}).catch((err) => {
							responseData = err.response.data.meta
							this.$snackOpen({contents:this.$t('344'), btnDisplayYN:true, btnDisplay:this.$t('345')}).then(() => {})

						})
				}
			})

		},
		checkSignInStatus(paramss) {
      let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck()
      loginAuth.then((response) => {
				let responseData = response.data.data;
				let changePasswordRequest = responseData.changePasswordRequest;
				let emailAuth = responseData.emailAuth;
				let dormancy = responseData.dormancy;
				let responsibilityAuth = responseData.responsibilityAuth;
				let termsAgree = responseData.termsAgree;
				let storeTransfer = responseData.storeTransfer;
				localStorage.setItem("userParams", JSON.stringify(paramss));
				if (this.isIdpService) {
					loginApi.setAuthInHeader(responseData.token);
				}

				if (dormancy === true) {
					this.$alert({
					title: this.$t("824"),
					content:
						this.$t("825") +
						" " +
						this.$t("826") +
						"<br>" +
						this.$t("827", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("828", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("829"),
					})
					.then(() => {
						this.login();
					})
					.catch(() => {
            this.login();
					});
				} else if (termsAgree === false) {
					this.$router.push("/termsagree");
				} else if (emailAuth === false) {
					this.$confirm({
					title: this.$t("804"),
					content: this.$t("805") + " " + this.$t("806"),
					accept: this.$t("835"),
					cancel: this.$t("834"),
					})
					.then(() => {
						this.$router.push("/emailvarification");
					})
					.catch(() => {
            this.login();
					});
				} else if (changePasswordRequest === true && this.next=='') {
					this.$router.push({ name: "MemberChangePassword" });
				} else if (responsibilityAuth === false) {
					this.$alert({
					title: this.$t("830"),
					content: this.$t("831") + " " + this.$t("832"),
					accept: this.$t("833"),
					})
					.then(() => {
						this.$router.push("/verificationcode");
					})
					.catch(() => {
            this.login();
					});
				} else if (storeTransfer !== null) {
					this.$router.push({ name: "StoreTransfer" });
				} else {
					popupApi
					.fetpopupDetail()
					.then((response) => {
						this.popupData = response.data.data;
						if (this.popupData.length > 0) {
						this.redirectPath =
							this.$route.query.redirectPath || '/home?showPopup=1';
						this.$router.push(this.redirectPath);
						} else {
						this.redirectPath = this.$route.query.redirectPath || "/home";
						//this.redirectPath = this.$route.query.redirectPath || '/degree'
						this.$router.push(this.redirectPath);
						}
					})
					.catch((error) => {
						console.log("err", error);
					});

					//this.$router.push(this.redirectPath)
				}
				})
				.catch((err) => {
				const responseData = err.response.data.meta;

				if (responseData.errCode === 1201) {
					// 관리자 승인 대기중(Waiting for administrator approval)
					// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
					//this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

					this.$alert({
					title: this.$t("779"), //가입 승인 대기 상태입니다.
					content:
						this.$t("780") +
						"<br>" +
						this.$t("781", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("782", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("783"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1202) {
					this.$alert({
					title: this.$t("779"), //가입 승인 대기 상태입니다.
					content:
						this.$t("780") +
						"<br>" +
						this.$t("781", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("782", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("783"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1204) {
					this.$alert({
					title: this.$t("1482"), //가입 승인 대기 상태입니다.
					content:
						this.$t("1483") +
						"<br>" +
						this.$t("1484") +
						": " +
						'<a href="mailto:' +
						BRAND_MANAGER_EMAIL +
						'">' +
						BRAND_MANAGER_EMAIL +
						"</a>" +
						"<br>" +
						this.$t("1485") +
						": " +
						'<a href="tel:' +
						BRAND_MANAGER_PHONE +
						'">' +
						BRAND_MANAGER_PHONE +
						"</a>",
					accept: this.$t("1486"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1205) {
					this.$alert({
					title: this.$t("1914"), //가입 승인 대기 상태입니다.
					content:
						this.$t("1915") +
						" " +
						this.$t("1916") +
						"<br>" +
						this.$t("1917", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("1918", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("1919"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1105) {
					this.$alert({
					content: this.$t("1875"),
					accept: this.$t("1876"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1335) {
					//아이디 계정 일시 정지(Suspend Account)
					// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
					this.$snackOpen({
					contents: this.$t("323"),
					btnDisplayYN: false,
					}).then(() => {});
				}
			});
		},
		signOutFirebase() {
			firebase.auth().signOut();
		},
		nextChangePassword() {
			let backTo = localStorage.getItem("changepassword")
				if(backTo === 'myinformation') {
					localStorage.removeItem("changepassword");
					this.$router.push({
					name: "MyInformation",
				})
			} else {
				this.next = 'next'
				this.checkSignInStatus(this.paramsss,this.next);
			}
		},
	}
}
</script>
<style scoped>
.check_show{
	display: block !important;
}
</style>
